import type {
  ProviderAnnouncementBannerColor,
  ProviderAnnouncementBannerIcon,
} from '@dev-console/provider-announcement-banner';

type IconPath = { d: string; evenOdd?: boolean };
type ColorClasses = { root: string; icon: string };

// Path data copied from client/src/components/custom/CustomIcon.tsx (24x24 viewBox).
const ICON_PATHS: Record<ProviderAnnouncementBannerIcon, IconPath[]> = {
  'information-circle-outline': [
    {
      evenOdd: true,
      d: 'M2.25 11.625C2.25 6.44782 6.44782 2.25 11.625 2.25C16.8022 2.25 21 6.44782 21 11.625C21 16.8022 16.8022 21 11.625 21C6.44782 21 2.25 16.8022 2.25 11.625ZM11.625 3.75C7.27624 3.75 3.75 7.27624 3.75 11.625C3.75 15.9738 7.27624 19.5 11.625 19.5C15.9738 19.5 19.5 15.9738 19.5 11.625C19.5 7.27624 15.9738 3.75 11.625 3.75ZM9.5625 10.3125C9.5625 9.89829 9.89829 9.5625 10.3125 9.5625H11.8125C12.2267 9.5625 12.5625 9.89829 12.5625 10.3125V15.1875H13.875C14.2892 15.1875 14.625 15.5233 14.625 15.9375C14.625 16.3517 14.2892 16.6875 13.875 16.6875H9.75C9.33579 16.6875 9 16.3517 9 15.9375C9 15.5233 9.33579 15.1875 9.75 15.1875H11.0625V11.0625H10.3125C9.89829 11.0625 9.5625 10.7267 9.5625 10.3125Z',
    },
    {
      d: 'M11.625 6.09375C11.384 6.09375 11.1483 6.16523 10.9479 6.29915C10.7475 6.43306 10.5913 6.62341 10.499 6.8461C10.4068 7.0688 10.3826 7.31385 10.4297 7.55027C10.4767 7.78668 10.5928 8.00384 10.7632 8.17429C10.9337 8.34473 11.1508 8.46081 11.3872 8.50783C11.6236 8.55486 11.8687 8.53072 12.0914 8.43848C12.3141 8.34623 12.5044 8.19002 12.6384 7.9896C12.7723 7.78918 12.8438 7.55355 12.8438 7.3125C12.8438 6.98927 12.7153 6.67927 12.4868 6.45071C12.2582 6.22215 11.9482 6.09375 11.625 6.09375Z',
    },
  ],
  'alert-circle-outline': [
    {
      evenOdd: true,
      d: 'M2.25 12C2.25 6.61704 6.61704 2.25 12 2.25C17.383 2.25 21.75 6.61704 21.75 12C21.75 17.383 17.383 21.75 12 21.75C6.61704 21.75 2.25 17.383 2.25 12ZM12 3.75C7.44546 3.75 3.75 7.44546 3.75 12C3.75 16.5545 7.44546 20.25 12 20.25C16.5545 20.25 20.25 16.5545 20.25 12C20.25 7.44546 16.5545 3.75 12 3.75Z',
    },
    {
      evenOdd: true,
      d: 'M11.9901 6.75238C12.1286 6.75106 12.2659 6.77797 12.3936 6.83148C12.5214 6.88502 12.6369 6.96406 12.7331 7.06375C12.8293 7.16346 12.9042 7.28173 12.9531 7.41134C13.0021 7.54095 13.0241 7.67918 13.0178 7.8176L12.7492 13.5352C12.7304 13.9353 12.4005 14.25 12 14.25C11.5995 14.25 11.2697 13.9353 11.2508 13.5353L10.9817 7.8176C10.9755 7.68083 10.9969 7.54422 11.0447 7.41591C11.0924 7.28761 11.1656 7.17024 11.2597 7.07081C11.3538 6.97139 11.467 6.89195 11.5925 6.83724C11.7179 6.78256 11.8531 6.7537 11.9899 6.75238',
    },
    {
      d: 'M12 17.2458C11.8146 17.2458 11.6333 17.1908 11.4792 17.0878C11.325 16.9848 11.2048 16.8384 11.1339 16.667C11.0629 16.4957 11.0443 16.3072 11.0805 16.1254C11.1167 15.9435 11.206 15.7765 11.3371 15.6454C11.4682 15.5143 11.6352 15.425 11.8171 15.3888C11.999 15.3526 12.1875 15.3712 12.3588 15.4421C12.5301 15.5131 12.6765 15.6333 12.7795 15.7874C12.8825 15.9416 12.9375 16.1229 12.9375 16.3083C12.9375 16.5569 12.8387 16.7954 12.6629 16.9712C12.4871 17.147 12.2486 17.2458 12 17.2458Z',
    },
  ],
  'warning-outline': [
    {
      d: 'M19.9875 21.6657H4.01252C3.64221 21.6657 3.2719 21.572 2.94846 21.3985C2.41877 21.1126 2.0344 20.6392 1.86096 20.0626C1.68752 19.486 1.74846 18.8767 2.0344 18.3517L10.0172 3.51572C10.411 2.78447 11.1703 2.33447 12 2.33447C12.8297 2.33447 13.5891 2.78916 13.9828 3.51572L21.9703 18.3517C22.1485 18.6798 22.2375 19.0454 22.2375 19.4204C22.2375 20.0204 22.0031 20.5876 21.5766 21.0095C21.1547 21.436 20.5922 21.6657 19.9875 21.6657ZM4.01252 20.1657H19.9922C20.1938 20.1657 20.3813 20.086 20.5219 19.9454C20.6625 19.8048 20.7422 19.6173 20.7422 19.4157C20.7422 19.2938 20.7094 19.1673 20.6531 19.0595L12.661 4.22822C12.4688 3.87197 12.136 3.83447 12 3.83447C11.8641 3.83447 11.5313 3.87197 11.3391 4.22822L3.35158 19.0642C3.25783 19.2423 3.2344 19.4438 3.29533 19.636C3.35158 19.8282 3.48283 19.9876 3.65627 20.0813C3.76408 20.1376 3.88596 20.1657 4.01252 20.1657Z',
    },
    {
      d: 'M12 15.628C11.6016 15.628 11.2688 15.314 11.25 14.9155L10.9828 9.19679C10.9828 9.1921 10.9828 9.18741 10.9828 9.18272V9.15929C10.9782 8.59679 11.4282 8.13741 11.9907 8.13272C12.0094 8.13272 12.0282 8.13272 12.0469 8.13272C12.6094 8.15616 13.0453 8.63429 13.0172 9.19679L12.75 14.9155C12.7313 15.314 12.3985 15.628 12 15.628Z',
    },
    {
      d: 'M12 18.6185C11.4844 18.6185 11.0625 18.1966 11.0625 17.681C11.0625 17.1654 11.4844 16.7435 12 16.7435C12.5156 16.7435 12.9375 17.1654 12.9375 17.681C12.9375 18.1966 12.5156 18.6185 12 18.6185Z',
    },
  ],
};

// Approximates ColorStyles in client/src/components/custom/Banner.tsx.
const COLOR_CLASSES: Record<ProviderAnnouncementBannerColor, ColorClasses> = {
  error: { root: 'bg-red-50 border-red-50', icon: 'text-red-600' },
  warning: { root: 'bg-yellow-50 border-yellow-50', icon: 'text-yellow-700' },
  info: { root: 'bg-blue-50 border-blue-50', icon: 'text-blue-500' },
  neutral: { root: 'bg-neutral-50 border-neutral-50', icon: 'text-neutral-700' },
  positive: { root: 'bg-green-50 border-green-50', icon: 'text-green-700' },
  ai: { root: 'bg-indigo-50 border-indigo-50', icon: 'text-indigo-500' },
};

function pick<T>(options: Record<string, T>, key: unknown, fallbackKey: string): T {
  const option = typeof key === 'string' && key in options ? options[key] : undefined;
  return option ?? options[fallbackKey]!;
}

export function BannerPreview({ value }: { value: Record<string, unknown> }) {
  const classes = pick<ColorClasses>(COLOR_CLASSES, value.color, 'neutral');
  const iconPaths = pick<IconPath[]>(ICON_PATHS, value.icon, 'information-circle-outline');
  const title = typeof value.title === 'string' ? value.title.trim() : '';
  const text = typeof value.text === 'string' ? value.text : '';

  return (
    <div className={`flex items-center gap-3 rounded-lg border px-4 py-3 ${classes.root}`}>
      <svg aria-hidden='true' viewBox='0 0 24 24' fill='currentColor' className={`size-6 shrink-0 ${classes.icon}`}>
        {iconPaths.map((path) => (
          <path
            key={path.d}
            d={path.d}
            fillRule={path.evenOdd ? 'evenodd' : undefined}
            clipRule={path.evenOdd ? 'evenodd' : undefined}
          />
        ))}
      </svg>
      <div className='flex min-w-0 flex-col gap-1'>
        {title !== '' && <div className='font-mediumbold text-neutral-900'>{title}</div>}
        <div className='break-words text-sm text-neutral-800'>
          {text || <span className='text-neutral-400'>No text</span>}
        </div>
      </div>
    </div>
  );
}
